/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
  import PRM from "@/core/PermissionConstants";

 export default {
   path: "/app/dental/historial",
   name: "DENTAL_HISTORY",
   component: () => import("@/app/views/DentalView.vue"),
   meta: {
     service: () => import("@/app/services/DentalHistoryService"),
     table: () => import("@/app/components/dental/history/DentalAppointmentHistoryTable.vue"),
     form: () => import("@/app/components/dental/history/DentalAppointmentHistoryForm.vue"),
     pdfModal: () => import("@/app/components/dental/pending/DentalAppointmentModalConfirm.vue"),
     header: {
       icono: "mdi-tooth",
       texto: "Historial de consultas | Dental",
       textNew: "Atender consulta | Dental",
       textEdit: "Editar consulta | Dental",
       textView: "Información de consulta | Dental",
     },
      prm: PRM.MODULE_DENTAL_HISTORY,
     requireAuth: true,
     filterDate: true,
     hideButtonAdd: true,
     filterModality: true,
     cancelationModal: true,
     generatePDFModal: false,
     isEdit: true,
     saveButtonText: "Guardar Consulta",
     labelDate: "Seleccione fecha",
     typeofTable: "history",
   },
 };
 